import { webAuthService } from 'xemelgoauthservice';

export default new webAuthService();
